import { Component, OnInit, Input } from '@angular/core'
import { FileService } from 'src/app/core/file.service'
import { phantomTestDetails_phantom_test_by_pk } from '../../../types/phantomTestDetails'
@Component({
  selector: 'app-test-reports',
  templateUrl: './test-reports.component.html',
  styleUrls: ['./test-reports.component.scss'],
})
export class TestReportsComponent implements OnInit {
  @Input() test: phantomTestDetails_phantom_test_by_pk

  constructor(private fileService: FileService) {}

  ngOnInit() {}

  get originalReportKey(): string {
    return this.test.rawOutput.report_summaryFile
  }

  get reportFile(): string {
    if (this.test && this.originalReportKey) {
      return this.fileService.getHostedUrl(this.originalReportKey)
    }
    return ''
  }
}
